import React, { memo } from 'react'
import { number, string } from 'prop-types'

export const BlockMonogramPiece2 = memo(({ color = '#003B5C', height = 134, width = 600 }) => {
	return (
		<svg
			width={width}
			height={height}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 232.2 51.9"
			style={{ enableBackground: 'new 0 0 232.2 51.9' }}
			xmlSpace="preserve"
		>
			<polyline fill={color} points="33.1,0.3 33.1,51.9 93.5,0.3 " />
		</svg>
	)
})
BlockMonogramPiece2.propTypes = {
	color: string,
	height: number,
	width: number,
}
